import { render } from "./EditRenewal.vue?vue&type=template&id=63d92c20&scoped=true"
import script from "./EditRenewal.vue?vue&type=script&lang=js"
export * from "./EditRenewal.vue?vue&type=script&lang=js"

import "./EditRenewal.vue?vue&type=style&index=0&id=63d92c20&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d92c20"]])

export default __exports__